import React, { useState, useEffect } from 'react';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Janmastami.scss';
import VratLinks from '../../../components/VratLinks/VratLinks';
import axios from 'axios';

import city from '../../../city.json'


const formatTime = (fullStr, format = '12hr') => {
  if (typeof fullStr !== 'string') return '--';

  // Match time with optional AM/PM
  const match = fullStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);

  if (!match) return fullStr; // If no match, return original string

  let [_, hh, mm, period] = match;
  let hours = parseInt(hh, 10);
  const minutes = parseInt(mm, 10);

  let replacementTime = '';

  if (format === '24hr' || format === '24hr+') {
    // Convert to 24-hour format
    if (period?.toUpperCase() === 'PM' && hours !== 12) hours += 12;
    if (period?.toUpperCase() === 'AM' && hours === 12) hours = 0;

    const paddedHours = hours.toString().padStart(2, '0');
    const paddedMinutes = minutes.toString().padStart(2, '0');

    replacementTime = `${paddedHours}:${paddedMinutes}`;
    if (format === '24hr+') {
      replacementTime += ':00'; // add seconds
    }
  } else {
    // 12-hour format
    let suffix = period;
    if (!suffix) {
      suffix = hours >= 12 ? 'PM' : 'AM';
    }

    if (hours === 0) {
      hours = 12;
    } else if (hours > 12) {
      hours = hours - 12;
    }

    replacementTime = `${hours}:${mm} ${suffix.toUpperCase()}`;
  }

  // Replace only the matched time part in the original string
  return fullStr.replace(match[0], replacementTime);
};

const Janmastami = () => {
  const [year, setYear] = useState(2025);
  const [location, setLocation] = useState('kolkata');
  const [timeFormat, setTimeFormat] = useState('12');

  const [janmaList, setJanmaList] = useState([]);
   const [tempLocation, setTempLocation] = useState("Kolkata");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedJanmashtami, setSelectedJanmashtami] = useState(null);


  const changeYear = (offset) => setYear((prev) => prev + offset);
  const handleYearInput = (e) => {
    const val = parseInt(e.target.value);
    if (!isNaN(val)) setYear(val);
  };

  const janmashtamiTooltips = {
  "Masik Krishna Janmashtami": "Masik Krishna Janmashtami is a monthly observance of Lord Krishna's birth on the Krishna Ashtami tithi. Devotees fast and pray to Lord Krishna, seeking his blessings for protection, wisdom, and spiritual upliftment.",
  "Krishna Janmashtami": "Krishna Janmashtami marks the divine birth of Lord Krishna, the eighth avatar of Vishnu. It is one of the most widely celebrated Hindu festivals, observed with fasting, night vigils, devotional singing, and reenactments of Krishna's life."
};


useEffect(() => {
  const fetchjanmaData = async () => {
    try {
     if (!location || location.trim() === '') return;
      const response = await axios.get(
        `https://core-c343.onrender.com/api/janmashtami?year=${year}&location=${encodeURIComponent(location)}`
      );
      
     
      if (response.data && response.data.janmashtamiDates) {
        setJanmaList(response.data.janmashtamiDates);
      } else {
        setJanmaList([]);
      }
   
 
    } catch (error) {
      console.error("Failed to fetch janma data:", error);
      setJanmaList([]);
    }
  };

  fetchjanmaData();
}, [year, location]);

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const [currentDate, setCurrentDate] = useState(new Date());


  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });

    const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

const handleSelect = (cityName) => {
  setTempLocation(cityName);
  setLocation(cityName); // 🔥 REQUIRED
  setSuggestions([]);
};



  return (
    <div className="Janmastami-container">
      <InnerNav />
      <div className="Janmastami-content">
        <Zodiac />

        {/* Ekadashi Calendar JSX starts here */}
        <div className="calendar-wrapper">
          <div className="calendar-header dark">
            <div className="highlight">
              <h2>{year} Janmashtami Dates</h2>
              <div className="current-ekadashi">
                <img src="https://rukminim2.flixcart.com/image/850/1000/kmp7ngw0/painting/e/z/a/8-kanha-ji-photo-frame-darsh-craft-original-imagfjqeymbewvbz.jpeg?q=90&crop=false" alt="Moon" className="moon-preview" />
                <div>
                 
                  <p>{location}</p>
                </div>
                 <div className="current-date">
                  <p><strong>{currentDate.getDate()}</strong></p>
                  <p>{readableDate}</p>
                  <p>{weekDay}</p>
                </div>
              </div>

              <div className="J-controls">
               <div className="location-date">
                   <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                  
                </div>
                <input type="number" value={year} onChange={handleYearInput} />
                <button onClick={() => changeYear(-1)}>Prev Year</button>
                <button onClick={() => setYear(new Date().getFullYear())}>Current Year</button>
                <button onClick={() => changeYear(1)}>Next Year</button>
                <div className="clock-modes">
                <button className={timeFormat === '12hr' ? 'active' : ''} onClick={() => setTimeFormat('12hr')}>
                    12 Hour
                  </button>
                  <button className={timeFormat === '24hr' ? 'active' : ''} onClick={() => setTimeFormat('24hr')}>
                    24 Hour
                  </button>
                  <button className={timeFormat === '24hr+' ? 'active' : ''} onClick={() => setTimeFormat('24hr+')}>
                    24 Plus
                  </button>
                  </div>
              </div>
            </div>
          </div>

{!selectedJanmashtami ? (
  <div className="janma-list">
    {janmaList.length === 0 && (
      <p>No janmashtami data available for selected year/location.</p>
    )}

    {janmaList.map((item, idx) => (
      <div
        className="janma-item clickable"
        key={idx}
        onClick={() => setSelectedJanmashtami(item)}
      >
        <img
          src="https://www.shutterstock.com/image-vector/hand-drawn-krishna-janmashtami-illustration-600nw-2489933897.jpg"
          alt={item.title}
        />

        <div className="janma-details">
          <p className="janma-date">{item.date}</p>

          <div className="janma-name">{item.title}</div>

          <p className="janma-phase">{item.nakshatra}</p>
          <p className="janma-tithi">{item.tithiName}</p>
          <p className="janma-tithi">{item.duration}</p>
        </div>

        <div className="janma-timings">
          <p>{item.lunarDetail}</p>
          <p>{formatTime(item.tithiStart, timeFormat)}</p>
          <p>{formatTime(item.tithiEnd, timeFormat)}</p>
        </div>
      </div>
    ))}
  </div>
) : (
  <div className="janma-detail-view">
    <button className="back-btn" onClick={() => setSelectedJanmashtami(null)}>
      ← Back
    </button>

    {/* HERO */}
    <div className="detail-hero">
      <img
        src="https://www.shutterstock.com/image-vector/hand-drawn-krishna-janmashtami-illustration-600nw-2489933897.jpg"
        alt={selectedJanmashtami.title}
      />
      <h2>{selectedJanmashtami.title}</h2>
    </div>

    {/* SIGNIFICANCE */}
    <section className="detail-section">
      <h3>🙏 Festival Significance</h3>
      <p>
        {janmashtamiTooltips[selectedJanmashtami.title] ||
          "Krishna Janmashtami celebrates the divine appearance of Lord Krishna, symbolizing the victory of righteousness over evil."}
      </p>
    </section>

    {/* DATE DETAILS */}
    <section className="detail-section">
      <h3>📅 Date & Panchang</h3>
      <p><strong>Date:</strong> {selectedJanmashtami.date}</p>
      <p><strong>Nakshatra:</strong> {selectedJanmashtami.nakshatra}</p>
      <p><strong>Tithi:</strong> {selectedJanmashtami.tithiName}</p>
      <p><strong>Duration:</strong> {selectedJanmashtami.duration}</p>
    </section>

    {/* TIMINGS */}
    <section className="detail-section">
      <h3>⏰ Important Timings</h3>
      <p><strong>Tithi Start:</strong> {formatTime(selectedJanmashtami.tithiStart, timeFormat)}</p>
      <p><strong>Tithi End:</strong> {formatTime(selectedJanmashtami.tithiEnd, timeFormat)}</p>
      <p><strong>Lunar Detail:</strong> {selectedJanmashtami.lunarDetail}</p>
    </section>

    {/* FASTING & RITUALS */}
    <section className="detail-section">
      <h3>🪔 Fasting & Rituals</h3>
      <p>
        Devotees observe a strict fast till midnight, perform Abhishekam of Lord Krishna,
        sing devotional bhajans, and celebrate Krishna’s birth at Nishita Kaal.
      </p>
    </section>

    {/* BENEFITS */}
    <section className="detail-section">
      <h3>✨ Spiritual Benefits</h3>
      <ul className="benefit-list">
        <li>Removes negative karma</li>
        <li>Brings peace and prosperity</li>
        <li>Strengthens devotion and discipline</li>
        <li>Blessings for children and family harmony</li>
      </ul>
    </section>
  </div>
)
}

        </div>
        {/* Ekadashi Calendar JSX ends here */}
            <VratLinks/>
        {/* <CommentBox/> */}
      </div>
      <Footer />
    </div>
  );
};

export default Janmastami;
